ACDiscountApp.CartPage.Show_CalculateTier = function () {
   let TierProducts = []; 
   let cartItemsCart = [];
    var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index) {
        if (isUpdate) {
            var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);
              if (isNotInRange || condition1) {

                jQuery('.cart-items .price.center .theme-money').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
                jQuery('.cart-items .total .theme-money').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
            }
            else {
                originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
                jQuery('.cart-items .price.center .theme-money').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
                jQuery('.cart-items .total .theme-money').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></div> <div style="margin-left:5px"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
            }
        }
    }

   var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
        if (isUpdate) {
            updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
            if (originalTotalPrice != updatedTotalPrice) {
                jQuery('.large-row-over.total .standard-title.total__amount .theme-money').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
               jQuery('.cart-summary__total-price-row.large-text .theme-money').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            }
            else {
                jQuery('.large-row-over.total .standard-title.total__amount .theme-money').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
               jQuery('.cart-summary__total-price-row.large-text .theme-money').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            }
        }
    }

    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          if (jQuery(window).width() < 700) {
            jQuery('#saved-banner-div').length == 0 ? jQuery('.grid__item.one-half.small-down--one-whole.text-right').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
          else{
            jQuery('#saved-banner-div').length == 0 ? jQuery('.grid__item.one-half.small-down--one-whole.text-right').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }

    var CheckoutClickCart = function () {
        jQuery('.small-row input[name="checkout"]').click(function () {
//             jQuery('[name="updates[]"]').each(function () {
//                 var qtyValue = this.value; var idAtrbtValue = jQuery(this).attr('id'); idAtrbtValue = idAtrbtValue.split('_'); idAtrbtValue = idAtrbtValue[1];
//                 idAtrbtValue = idAtrbtValue.split(':'); idAtrbtValue = idAtrbtValue[0];
//                 for (i = 0; i < globalFieldsCartPage_AC.cartObj.items.length; i++) {
//                     if (globalFieldsCartPage_AC.cartObj.items[i].variant_id == Number(idAtrbtValue)) { globalFieldsCartPage_AC.cartObj.items[i].quantity = Number(qtyValue); }
//                 }
//             });
            TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
            GetCode(false);
        });
    }

    var CheckoutClickAjax = function () {
        jQuery('#cart-notification-form').click(function (e) {
            e.preventDefault();
            GetCode(true);
        });
    }

let AdditionAmount = 0;
let AdditonalDiscountObj = {};
let marketregion = globalFields.CuurencyCode();
let conversionRate = globalFields.cunversionRate();
var ValidateCode = function (isUpdateCart) {
   let CartPrice__= globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.original_total_price / 100);
      //  let Token = $('#ac-additional-amount-off div span:first').text();
      //   Token = Token.split(" ")[1] != undefined ? Token.split(" ")[1] : '';
      // if(Token == "" || Token == null ){
        var discount_code = $('#ac-additional-discount-text').val(); $('#ac-additional-valid-invalid-code').html(''); $('#ac-additional-valid-invalid-code').html('');       
    
  if (discount_code != "") {
            $('#ac-additional-discount-btn').prop('disabled', true); $('#ac-additional-discount-btn').addClass('disabled');
            $.ajax({
                type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateAdditionalCode",
            
                data: { DiscountCode: discount_code, CustomerId: customer_id, Subtotal: CartPrice__},
                success: function (data_) {
                  
         
                    if (data_.IsValid) {

   if(data_.prerequisite_to_entitlement_quantity_ratio.entitled_quantity == null || data_.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity == null ){
                         if (data_.IsMeetRequirement) {
                          
                            if (data_.target_type=="shipping_line") {
                               $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled');
                              $('#ac-additional-valid-invalid-code').html('<span>' + $('#ac-additional-cart-discount-requirement').text() + '</span>');
                            }else{
                              AdditonalDiscountObj.value = data_.value;
                              AdditonalDiscountObj.value_type = data_.value_type;
                            var v = Math.abs(data_.value); var subtotalPrice = 0, totalOff = 0;
                            if (data_.target_type == 'line_item' && data_.target_selection == 'all') {
                                if (data_.value_type == 'percentage') {
                                   v =  parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(v) / 100) * CartPrice__));
                                }
                                var allQty = 0;
                                for (i = 0; i < globalFieldsCartPage_AC.cartObj.items.length; i++) {
                                    allQty += globalFieldsCartPage_AC.cartObj.items[i].variant_id.quantity;
                                    if (jQuery.inArray(globalFieldsCartPage_AC.cartObj.items[i].variant_id, variantIdsToSend) == -1) {
                                        variantIdsToSend.push(globalFieldsCartPage_AC.cartObj.items[i].variant_id);
                                        // minimumDiscountSubtotal += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                                       // minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.items[i].original_line_price / 100);
                                    }
                                }
                                subtotalPrice = CartPrice__ - v;
                                totalOff = CartPrice__ - subtotalPrice;
                                // priceDiff = priceDiff + totalOff;
                              AdditionAmount = totalOff;
                            }
                            else if (data_.target_type == 'line_item' && data_.target_selection == 'entitled') {
                                var allQty = 0, temp_lineitem_subtotal = 0;
                                if (data_.entitled_variant_ids.length != 0) {
                                    for (i = 0; i < globalFieldsCartPage_AC.cartObj.items.length; i++) {
                                        if (jQuery.inArray(globalFieldsCartPage_AC.cartObj.items[i].variant_id, data_.entitled_variant_ids) !== -1) {
                                            allQty += globalFieldsCartPage_AC.cartObj.items[i].quantity;
                                            temp_lineitem_subtotal =  CartPrice__;
                                            // temp_lineitem_subtotal += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                                            if (jQuery.inArray(globalFieldsCartPage_AC.cartObj.items[i].variant_id, variantIdsToSend) == -1) {
                                                variantIdsToSend.push(globalFieldsCartPage_AC.cartObj.items[i].variant_id);
                                                // minimumDiscountSubtotal += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                                                 // minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.items[i].original_line_price / 100);
                                            }
                                        }
                                    }
                                }
                                else if (data_.entitled_product_ids.length != 0) {
                                    for (i = 0; i < globalFieldsCartPage_AC.cartObj.items.length; i++) {
                                        if (jQuery.inArray(Number(globalFieldsCartPage_AC.cartObj.items[i].product_id), data_.entitled_product_ids) !== -1) {
                                            allQty += globalFieldsCartPage_AC.cartObj.items[i].quantity;
                                                     temp_lineitem_subtotal = CartPrice__;
                                            // temp_lineitem_subtotal += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                                            if (jQuery.inArray(globalFieldsCartPage_AC.cartObj.items[i].variant_id, variantIdsToSend) == -1) {
                                                variantIdsToSend.push(globalFieldsCartPage_AC.cartObj.items[i].variant_id);
                                                // minimumDiscountSubtotal += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                                               // minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.items[i].original_line_price / 100);
                                            }
                                        }
                                    }
                                }
                                else if (data_.entitled_collection_ids.length != 0) {
                                    var variantIdsDone = [];
                                    for (k = 0; k < data_.entitled_collection_ids.length; k++) {
                                        for (i = 0; i < globalFieldsCartPage_AC.cartObj.items.length; i++) {
                                            if (jQuery.inArray(data_.entitled_collection_ids[k], globalFieldsCartPage_AC.cartObj.items[i].collection_ids) !== -1) {
                                                if (jQuery.inArray(globalFieldsCartPage_AC.cartObj.items[i].variant_id, variantIdsDone) === -1) {
                                                    variantIdsDone.push(globalFieldsCartPage_AC.cartObj.items[i].variant_id);
                                                    allQty += globalFieldsCartPage_AC.cartObj.items[i].quantity;
                                                            temp_lineitem_subtotal = CartPrice__;
                                                    // temp_lineitem_subtotal += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                                                    if (jQuery.inArray(globalFieldsCartPage_AC.cartObj.items[i].variant_id, variantIdsToSend) == -1) {
                                                        variantIdsToSend.push(globalFieldsCartPage_AC.cartObj.items[i].variant_id);
                                                        // minimumDiscountSubtotal += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                                                         // minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.items[i].original_line_price / 100);
                                
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                if (data_.prerequisite_subtotal_range == null || (temp_lineitem_subtotal >= data_.prerequisite_subtotal_range.greater_than_or_equal_to)) {
                                    if (data_.value_type == 'percentage') {
                                       // v =  parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(v) / 100) * globalFields.ConvertToFixedDecimalNumber(temp_lineitem_subtotal / 100)));
                                       v =  parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(v) / 100) * globalFields.ConvertToFixedDecimalNumber(temp_lineitem_subtotal)));
                                    }
                                    if (data_.value_type == 'fixed_amount' && data_.allocation_method == 'each') {
                                        v = Number((v * allQty).toFixed(2));
                                    }
                                    subtotalPrice = temp_lineitem_subtotal - v;
                                    totalOff = temp_lineitem_subtotal - subtotalPrice;
                                    // priceDiff = priceDiff + totalOff;
                                   AdditionAmount = totalOff;
                                    }
                                    }
                            $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled');
                            if (totalOff > 0) {
                            var superOrignalPrice = 0;
                           	for(var i=0;i<globalFieldsCartPage_AC.cartObj.items.length;i++)
                            {
                              superOrignalPrice = CartPrice__;
                             // superOrignalPrice += globalFieldsCartPage_AC.cartObj.items[i].original_line_price;
                             }
                              var tempmsg = $('input#ac-additional-discount-text').val();
                                // $('#ac-additional-valid-invalid-code').html('<span>' + $('#ac-additional-cart-discount-successful').text() + '</span>'); $('#ac-additional-amount-off').html('<span>' + globalFields.currencySymbol + totalOff.toFixed(2) + ' off! </span> <span id="cancelDiscount" style="cursor:pointer"><svg style="max-width: 13;max-height: 13px;" class="icon-svg icon-svg--color-adaptive-light icon-svg--size-16 reduction-code__icon" aria-hidden="true" focusable="false"> <use xlink:href="#tags-filled"><svg id="tags-filled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></svg></use></svg></span>');
                              $('#ac-additional-valid-invalid-code').html('<span>' + $('#ac-additional-cart-discount-successful').text() + '</span>');
                               $('#ac-additional-amount-off').html('<div><span>' +'<svg style="max-width: 13;max-height: 13px;" class="icon-svg icon-svg--color-adaptive-light icon-svg--size-16 reduction-code__icon" aria-hidden="true" focusable="false"> <use xlink:href="#tags-filled"><svg id="tags-filled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></svg></use></svg>'  + tempmsg  +  ' </span> <span id="cancelDiscount"  style="cursor:pointer;color: red;" onclick=javascript:window.location.reload() >X</span></div><p>This discount will be calculated on checkout.</p>');
                               // $('#ac-additional-amount-off').html('<div><span>' +'<svg style="max-width: 13;max-height: 13px;" class="icon-svg icon-svg--color-adaptive-light icon-svg--size-16 reduction-code__icon" aria-hidden="true" focusable="false"> <use xlink:href="#tags-filled"><svg id="tags-filled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></svg></use></svg>'  + tempmsg + ' (-' + globalFields.currencySymbol + totalOff.toFixed(2) + ') USD' +  ' </span> <span id="cancelDiscount"  style="cursor:pointer;color: red;" onclick=javascript:window.location.reload() >X</span></div><p>This discount will be calculated on checkout.</p>');
                              // UpdateCartSubtotal(true, globalFields.ConvertToFixedDecimalNumber(Number((superOrignalPrice/100) - (priceDiff))),superOrignalPrice/100);
                              // UpdateSavingMessage(true);
                              $('input#ac-additional-discount-text').val('');
                                $("#ac-additional-discount-btn").attr('disabled', true);
                               $("input#ac-additional-discount-text").attr('disabled', true);
                               
                            }
                            else {
                                $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled');
                                $('#ac-additional-valid-invalid-code').html('<span>' + $('#ac-additional-cart-discount-requirement').text() + '</span>');
                            }
                        }
                        }
                        else {
                            $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled');
                            $('#ac-additional-valid-invalid-code').html('<span>' + $('#ac-additional-cart-discount-requirement').text() + '</span>');
                        }
                     
                        }else {
                            $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled');
                            $('#ac-additional-valid-invalid-code').html('<span>' + $('#ac-additional-cart-discount-requirement').text() + '</span>');
                        }
                         }
                    else {
                        $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled');
                        $('#ac-additional-valid-invalid-code').html('<span>' + $('#ac-additional-cart-discount-invalid').text() + '</span>');
                    }
                },
                error: function (e) { console.log(e.statusText); $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled'); }
            });
        }else{
            $('#ac-additional-discount-btn').prop('disabled', false); $('#ac-additional-discount-btn').removeClass('disabled');
            $('#ac-additional-valid-invalid-code').html('<span> Discount code is required.</span>');
           $('#ac-additional-amount-off').html('');
           $("#ac-additional-discount-btn").attr('disabled', false);
            $("input#ac-additional-discount-text").attr('disabled', false);
            }


       //  }else{
       //   $("#ac-additional-discount-text").before('<span style="display:block" id="ac-additional-AlreadyAppleid">Discount has already been applied</span>')
       //   $("#ac-additional-discount-btn").attr('disabled', 'disabled');
       //   $("input#ac-additional-discount-text").attr('disabled', 'disabled');
       //  setTimeout(function() {
       //   $("#ac-additional-AlreadyAppleid").remove();
       // },3000);
        
        // }
}
  var GetCode = function (isUpper) {
    
        if (priceDiff > 0 ||  AdditionAmount > 0) {
            let Token = $('#ac-additional-amount-off div span:first').text();
         Token = Token.split(" ")[1] != undefined ? Token.split(" ")[1] : '';
          var temp_CustObject = JSON.stringify({ customer_id:customer_id, customer_first_name:customer_first_name,customer_last_name:customer_last_name, customer_email:customer_email });
            jQuery.ajax({
                type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateDiscountCodeContry",
                data: {conversionRate:JSON.stringify(conversionRate),TierProductsarray:JSON.stringify(TierProducts),cartItemsObj: JSON.stringify(globalFieldsCartPage_AC.cartObj),priceDifference:AdditionAmount,DiscountText:Token, temp_CustObject: temp_CustObject ,AdditionalObj:JSON.stringify(AdditonalDiscountObj),marketregion:marketregion},
                     success: function(result) {
                       
                  // setTimeout(function() {
                  window.location.href = result;
                  
                  // },3000);
                  
                  },
                  error: function (e) { 
                  window.location.href = '/checkout'; 
                  }
            });
        }
        else if (isUpper) {
            window.location.href = '/checkout';
        }
      else{
        window.location.href = '/checkout';
      }
    }
  
  var CartPageDiscount = function () {
        jQuery('#ac-additional-discount-btn').click(function (e) {
            ValidateCode(true);
        });
    	}
    var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
    }

    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;

  	var hide_buttons = null;
  	var HideAdditionalPayments = function() {      
      hide_buttons = setInterval(function() {
        if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
          jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
          clearInterval(hide_buttons);
        }
      }, 500);
    }
  
    var TieredPricingCart = function (cartObject, isUpdate) {
       cartItemsCart = cartObject;
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);
            
          if (itemTiers != undefined && itemTiers.status && globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
            
            let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
               if(DiscountAppliedOn){
                if(Location_Tag_s){
                   let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                   let LocationObject = Object.keys(itemTiers.Location_Tag_);
                   if(LocationObject[0] == 'StoreLocation'){
                    let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                    if(StoreLocationcheck && DiscountAppliedOnTag){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                      }else{
                      updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                      }
                   }else{
                   let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                     if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                     }else{
                       updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }
                                                   
                 }else{
                  if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                   var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                  updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                  if (rslt[1]) {
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                 }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
                 }
                 
               }else{
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                }
                 
               }

            
             }
            else {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
          
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
            }
        }
      
        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
       cartItemsCart = cartObject;
      	if(priceDiff){
          HideAdditionalPayments();
        }
      	setTimeout(function(){
          clearInterval(hide_buttons);
        }, 5000);
    }
setTimeout(function(){
      clearInterval(hide_buttons);
    }, 10000);
    
    var GetTiersFromTiersArray = function (variantId) {
      
        var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
        if (tierObj[0].tiers == "[]") {
            return undefined;
        }
        else {
            return globalFields.GetTierObject(tierObj[0].tiers, variantId);
        }
    }

    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
      
       let isFound = TierProducts.some(element => {if (element.VarientID === item.variant_id) { return true;}return false;});
        for (i = 0; i < itemTiers.tier_min.length; i++) {
           let tempTierProductsobj = {};
            var allVariantItemQty = 0;
            var tierPrice = parseFloat(itemTiers.tier_values[i]);
            var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
            var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;

            if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                else {
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }

            if (condition1 && condition2) {
                isNotInRange = false;
                if (itemTiers.discount_type == 'percentage') {
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
                   if(!isFound){
                      tempTierProductsobj['Discountvalue'] = tierPrice;
                      tempTierProductsobj['DiscountType'] = itemTiers.discount_type;
                      tempTierProductsobj['VarientID'] = item.variant_id;
                    } else{
                      TierProducts.find(obj => obj.VarientID == item.variant_id).Discountvalue = tierPrice;
                    } 
                }
                else if (itemTiers.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice));
                    if(!isFound){
                      tempTierProductsobj['Discountvalue'] = tierPrice;
                      tempTierProductsobj['DiscountType'] = itemTiers.discount_type;
                      tempTierProductsobj['VarientID'] = item.variant_id;
                    } else{
                      TierProducts.find(obj => obj.VarientID == item.variant_id).Discountvalue = tierPrice;
                    } 
                }
                else if (itemTiers.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                    if(!isFound){
                      tempTierProductsobj['Discountvalue'] = tierPrice;
                      tempTierProductsobj['DiscountType'] = itemTiers.discount_type;
                      tempTierProductsobj['VarientID'] = item.variant_id;
                    } else{
                      TierProducts.find(obj => obj.VarientID == item.variant_id).Discountvalue = tierPrice;
                    } 
                }

                if (updatedItemPrice < 0) { updatedItemPrice = 0; }
                updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index);
              if(!isFound){
                TierProducts.push(tempTierProductsobj);
              }
            }
           for (var z = 0; z < cartItemsCart.items.length; z++) {
                  if(updatedItemPrice !=0 ){
                     cartItemsCart.items[index].discountedPrice = updatedItemPrice;
                     break;
                  }
                   
                }
        }
        if (isNotInRange) {
            UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
        }
        return [updatedTotalPrice, isNotInRange];
    }

    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    /*
        var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
        function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
        function sendReplacement(data) {
            this.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    ProcessCartResponse(this._url, this.responseText);
                }
            };
            return send.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });

    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                setTimeout(function () {
                    FetchCartTiers();
                }, 800);
            }
        }
    }

    try{
        var nativeFetch = window.fetch;
        window.fetch = function(...args) {
          if(args[0].includes("/cart/change") || args[0].includes("/cart/add")){
            setTimeout(function () {
              fetch('/cart.js')
              .then(r =>  r.json().then(data => ({status: r.status, body: data})))
              .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
            }, 500);
          }
          return nativeFetch.apply(window, args);
        }
      }
      catch(e){}
  
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();CartPageDiscount();
}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();